import getConfig from "next/config";

const { publicRuntimeConfig } = getConfig();

const ENVIRONMENT: "prod" | "stg" | "dev" =
  publicRuntimeConfig && publicRuntimeConfig.ENVIRONMENT
    ? publicRuntimeConfig.ENVIRONMENT
    : "dev";

/**
 *
 * @returns Base URL that points to the Registration Dashboard (fe-registration-dashboard)
 */
export const getRegistrationUrl = () => {
  /**
   * HOPIN_REGISTRATION_ROOT environment variable is only used for local development
   * in case you are running fe-registration-dashboard on your machine and
   * wish to connect Canvas to it
   */
  const { HOPIN_REGISTRATION_ROOT } = publicRuntimeConfig;

  if (HOPIN_REGISTRATION_ROOT) {
    return HOPIN_REGISTRATION_ROOT;
  }

  //  Verify if its running under Hopin Domain
  if (
    global.window &&
    window.location.hostname &&
    window.location.hostname.endsWith("hopin.com")
  ) {
    const sufix = ENVIRONMENT === "prod" ? "" : `-${ENVIRONMENT}`;
    return `https://registration${sufix}.hopin.com`;
  }

  //  Otherwise, use RingCentral Domain
  const sufix = ENVIRONMENT === "prod" ? "" : ".staging";
  return `https://registration${sufix}.events.ringcentral.com`;
};
